// Возврат со входа Steam — не источник захода, а наш же вход. По адресу источника его не узнать:
// браузер (политика `strict-origin-when-cross-origin`) отдаёт сайту только
// `https://steamcommunity.com/`, без пути `/openid`, — как и при обычной ссылке со Steam. Поэтому
// перед уходом на вход вкладка получает отметку в `sessionStorage`: она живёт, пока открыта
// вкладка, и переживает переход на Steam и обратно.

const STORAGE_KEY = "relock.steamLogin";
const STEAM_COMMUNITY = /^(www\.)?steamcommunity\.com$/;

// Отметить, что эта вкладка уходит на вход Steam. Хранилище недоступно — без отметки.
export const markSteamLogin = (storage: Storage = window.sessionStorage): void => {
  try {
    storage.setItem(STORAGE_KEY, "1");
  } catch {
    // Без хранилища возврат посчитается заходом со Steam.
  }
};

// Пришли со Steam после входа: со страницы OpenID или со steamcommunity.com во вкладке, которая
// уходила на вход. Такой посетитель уже был на сайте и посчитан по своему источнику.
export const isSteamLoginReturn = (
  referrer: URL,
  storage: Storage = window.sessionStorage,
): boolean => {
  if (!STEAM_COMMUNITY.test(referrer.hostname)) {
    return false;
  }
  if (referrer.pathname.startsWith("/openid")) {
    return true;
  }
  try {
    return storage.getItem(STORAGE_KEY) !== null;
  } catch {
    return false;
  }
};
